import React, { Component } from 'react'
import BoardItem from '../component/BoardItem'
import { Table, Icon } from 'antd'
import './style.less'
import { getStatistics } from '../../../api/api'

// 为 true 时不在页面展示对应统计块（接口与 state 仍保留）
const HIDE_PLATFORM_TICKET = true // 汽车票流水
const HIDE_PLATFORM_TRAVEL = true // 旅游专线
const HIDE_PLATFORM_HEALTH = true // 健康专线

export default class setting extends Component {
    state = {
        data: {
            merchant: [[{ name: '商家流水' }]],
            merchantTopup: [{ name: '商家充值' }],
            commission: [{ name: '佣金流水' }],
            health: [{ name: '健康专线' }],
            travel: [{ name: '旅游专线' }],
            ticket: [{ name: '汽车票' }],
            store: [{ name: '商城流水' }],
        }
    }
    componentDidMount () {
        getStatistics().then(res => {
            // 组织汽车票的数据结构
            this.setState({
                merchant: [{ name: '商家流水', ...res.data.merchant }],
                merchantTopup: [{ name: '商家充值', ...res.data.merchantTopup }],
                commission: [{ name: '佣金流水', ...res.data.commission }],
                health: [{ name: '健康专线', ...res.data.health }],
                travel: [{ name: '旅游专线', ...res.data.travel }],
                ticket: [{ name: '汽车票', ...res.data.ticket }],
                store: [{ name: '商城流水', ...res.data.store }],
            })
        })
    }

    render () {
        const columns = [
            {
                title: '类型',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '订单数',
                dataIndex: 'orderCount',
                key: 'orderCount',
            },
            {
                title: '流水总额',
                render: (c) => {
                    return (c.orderMoney / 100).toFixed(2)
                },
                key: 'orderMoney',
            },
            {
                title: '退票总额',
                render: (c) => {
                    return (c.refundMoney / 100).toFixed(2)
                },
                key: 'refundMoney',
            },
            {
                title: '退票单数',
                dataIndex: 'refundCount',
                key: 'refundCount',
            },
            {
                title: '退票手续费',
                render: (c) => {
                    return (c.feeMoney / 100).toFixed(2)
                },
                key: 'feeMoney',
            },
            {
                title: '实际订单数',
                dataIndex: 'actualCount',
                key: 'actualCount',
            },
            {
                title: '实际总流水',
                render: (c) => {
                    return (c.actualMoney / 100).toFixed(2)
                },
                key: 'actualMoney',
            },

        ]
        const columns2 = [
            {
                title: '类型',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '订单数',
                dataIndex: 'orderCount',
                key: 'orderCount',
            },
            {
                title: '流水总额',
                render: (c) => {
                    return (c.orderMoney / 100).toFixed(2)
                },
                key: 'orderMoney',
            },
            {
                title: '退货总金额',
                render: (c) => {
                    return (c.refundMoney / 100).toFixed(2)
                },
                key: 'refundMoney',
            },
            {
                title: '退货单数',
                dataIndex: 'refundCount',
                key: 'refundCount',
            },
            {
                title: '实际订单数',
                dataIndex: 'actualCount',
                key: 'actualCount',
            },

            {
                title: '实际总流水',
                render: (c) => {
                    return (c.actualMoney / 100).toFixed(2)
                },
                key: 'actualMoney',
            },

        ]
        const columns3 = [
            {
                title: '类型',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '订单数',
                dataIndex: 'orderCount',
                key: 'orderCount',
            },
            {
                title: '流水总金额',
                render: (c) => {
                    return (c.orderMoney / 100).toFixed(2)
                },
                key: 'orderMoney',
            },
            {
                title: '退票单数',
                dataIndex: 'refundCount',
                key: 'refundCount',
            },
            {
                title: '退票流水',
                render: (c) => {
                    return (c.refundMoney / 100).toFixed(2)
                },
                key: 'refundMoney',
            },
            {
                title: '实际订单数',
                dataIndex: 'actualCount',
                key: 'actualCount',
            },

            {
                title: '实际总流水',
                render: (c) => {
                    return (c.actualMoney / 100).toFixed(2)
                },
                key: 'actualMoney',
            },

        ]
        const columns4 = [
            {
                title: '类型',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '订单数',
                dataIndex: 'orderCount',
                key: 'orderCount',
            },
            {
                title: '流水总金额',
                render: (c) => {
                    return (c.orderMoney / 100).toFixed(2)
                },
                key: 'orderMoney',
            },
            {
                title: '退票总金额',
                dataIndex: 'refundMoney',
                key: 'refundMoney',
            },
            {
                title: '退票单数',
                dataIndex: 'refundCount',
                key: 'refundCount',
            },
            {
                title: '退票手续费',
                render: (c) => {
                    return (c.feeMoney / 100).toFixed(2)
                },
                key: 'feeMoney',
            },
            {
                title: '实际订单数',
                dataIndex: 'actualCount',
                key: 'actualCount',
            },

            {
                title: '客分',
                render: (c) => {
                    return (c.ticketMoney / 100).toFixed(2)
                },
                key: 'ticketMoney',
            },
            {
                title: '平台',
                render: (c) => {
                    return (c.platformMoney / 100).toFixed(2)
                },
                key: 'platformMoney',
            },
            {
                title: '第三方',
                render: (c) => {
                    return (c.foreignMoney / 100).toFixed(2)
                },
                key: 'foreignMoney',
            },
        ]
        const columns5 = [
            {
                title: '类型',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '佣金总金额',
                render: (c) => {
                    return (c.totalCommission / 100).toFixed(2)
                },
                key: 'totalCommission',
            },
            {
                title: '冻结金额',
                render: (c) => {
                    return (c.frozenCommission / 100).toFixed(2)
                },
                key: 'frozenCommission',
            },
            {
                title: '可提现金额',
                render: (c) => {
                    return (c.commission / 100).toFixed(2)
                },
                key: 'commission',
            },
            // {
            //     title: '第三方',
            //     dataIndex: 'address',
            //     key: 'address',
            // },

        ]
        const columns6 = [
            {
                title: '类型',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '总单数',
                dataIndex: 'orderCount',
                key: 'orderCount',
            },
            {
                title: '总金额',
                render: (c) => {
                    return (c.money / 100).toFixed(2)
                },
                key: 'money',
            },
            // {
            //     title: '已发放',
            //     dataIndex: 'address',
            //     key: 'address',
            // },
            // {
            //     title: '剩余',
            //     dataIndex: 'address',
            //     key: 'address',
            // },

        ]
        const columns7 = [
            {
                title: '类型',
                dataIndex: 'name',
                key: 'name',
            },

            {
                title: '总金额',
                render: (c) => {
                    return (c.totalMoney / 100).toFixed(2)
                },
                key: 'totalMoney',
            },
            {
                title: '可提现金额',
                render: (c) => {
                    return (c.balance / 100).toFixed(2)
                },
                key: 'balance',
            },
            {
                title: '冻结金额',
                render: (c) => {
                    return (c.frozenBalance / 100).toFixed(2)
                },
                key: 'frozenBalance',
            },
        ]
        return (
            <div className='merchants-page'>
                <div className='board'>
                    <BoardItem
                        icon='pay-circle'
                        itemKey='总金额'
                        itemValue='0'
                    />

                    <BoardItem
                        icon='line-chart'
                        itemKey='总订单数'
                        itemValue='0'

                    />

                </div>
                {!HIDE_PLATFORM_TICKET && (
                <div className='tablecontain'>
                    <div className='contain-title'>
                        <Icon type="unordered-list" /> 汽车票流水</div>
                    <Table
                        bordered
                        columns={columns}
                        dataSource={this.state.ticket}
                        pagination={false}
                        rowKey='id'
                    />
                </div>
                )}
                <div className='tablecontain'>
                    <div className='contain-title'>
                        <Icon type="unordered-list" /> 商城流水</div>
                    <Table
                        bordered
                        columns={columns2}
                        dataSource={this.state.store}
                        pagination={false}
                        rowKey='id'
                    />
                </div>
                {!HIDE_PLATFORM_TRAVEL && (
                <div className='tablecontain'>
                    <div className='contain-title'>
                        <Icon type="unordered-list" /> 旅游专线</div>
                    <Table
                        bordered
                        columns={columns3}
                        dataSource={this.state.travel}
                        pagination={false}
                        rowKey='id'
                    />
                </div>
                )}
                {!HIDE_PLATFORM_HEALTH && (
                <div className='tablecontain'>
                    <div className='contain-title'>
                        <Icon type="unordered-list" /> 健康专线</div>
                    <Table
                        bordered
                        columns={columns4}
                        dataSource={this.state.health}
                        pagination={false}
                        rowKey='id'
                    />
                </div>
                )}
                <div className='tablecontain'>
                    <div className='contain-title'>
                        <Icon type="unordered-list" /> 佣金流水</div>
                    <Table
                        bordered
                        columns={columns5}
                        dataSource={this.state.commission}
                        pagination={false}
                        rowKey='id' 
                    />
                </div>
                <div className='tablecontain'>
                    <div className='contain-title'>
                        <Icon type="unordered-list" /> 商家充值</div>
                    <Table
                        bordered
                        columns={columns6}
                        dataSource={this.state.merchantTopup}
                        pagination={false}
                        rowKey='id'
                    />
                </div>
                <div className='tablecontain'>
                    <div className='contain-title'>
                        <Icon type="unordered-list" /> 商家流水</div>
                    <Table
                        bordered
                        columns={columns7}
                        dataSource={this.state.merchant}
                        pagination={false}
                        rowKey='id'
                    />
                </div>
            </div>
        )
    }
}

